import { Injectable } from '@angular/core';
// import { Subject } from “rxjs/Subject”;
import {Observable,throwError,BehaviorSubject } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class LanguageService {
 

  private switchLanguage = new BehaviorSubject<any>('english')
  currenLanguage = this.switchLanguage.asObservable(); 
  changeLanguage(switchLanguage: any) {
    
    this.switchLanguage.next(switchLanguage)
  }
}
